import React from 'react';
import Link from 'next/link';

export default function CategoryNav({ categories = [], activeSlug = null }) {
  return (
    <div className="d-flex align-items-center gap-2 overflow-x-auto pb-2 mb-4 scrollbar-hidden">
      <Link
        href="/blog"
        className={`btn rounded-pill px-4 py-2 fw-semibold text-nowrap transition-all ${
          !activeSlug
            ? 'btn-primary text-white shadow-sm'
            : 'btn-outline-secondary border-0 bg-white text-secondary hover-bg-light shadow-sm'
        }`}
      >
        Todos os Artigos
      </Link>
      {categories.map((cat) => {
        const isActive = activeSlug === cat.slug;
        return (
          <Link
            key={cat.id || cat.slug}
            href={`/blog/categoria/${cat.slug}`}
            className={`btn rounded-pill px-4 py-2 fw-semibold text-nowrap transition-all ${
              isActive
                ? 'btn-primary text-white shadow-sm'
                : 'btn-outline-secondary border-0 bg-white text-secondary hover-bg-light shadow-sm'
            }`}
          >
            {cat.name}
            {cat.count ? (
              <span
                className={`badge ms-2 rounded-pill ${
                  isActive ? 'bg-white text-primary' : 'bg-light text-muted'
                }`}
              >
                {cat.count}
              </span>
            ) : null}
          </Link>
        );
      })}
    </div>
  );
}
